<template>
  <path pid="0" d="M17.54 24H8.46a1 1 0 01-1-1v-4.46H3a1 1 0 01-1-1V8.46a1 1 0 011-1h4.46V3a1 1 0 011-1h9.08a1 1 0 011 1v4.46H23a1 1 0 011 1v9.08a1 1 0 01-1 1h-4.46V23a1 1 0 01-1 1zm-8.08-2h7.08v-4.46a1 1 0 011-1H22V9.46h-4.46a1 1 0 01-1-1V4H9.46v4.46a1 1 0 01-1 1H4v7.08h4.46a1 1 0 011 1z"/>
</template>
